import { Component, OnInit, OnDestroy } from '@angular/core';
import { firstValueFrom, Subscription } from 'rxjs';

import { IApplicationContextService, ISimulationService } from '../../services/services';
import { SimulationHeader } from '../../models/simulation';
import { SimulationCommon } from '../functions/simulationCommon';
import { CompanyNameViewModel } from '../../services/nswag/nswagclient';

@Component({
    selector: 'simulation-list',
    templateUrl: './simulation-list.component.html',
    styleUrls: ['./simulation-list.component.css'],
    standalone: false
})
export class SimulationListComponent implements OnInit, OnDestroy {
  private _companyContextSubscription?: Subscription;
  company: CompanyNameViewModel | null = null;
  simulationHeaders: SimulationHeader[] = [];

  constructor(
    private _applicationContextService: IApplicationContextService,
    private _simulationService: ISimulationService
  ) { }

  ngOnDestroy() {
    this._companyContextSubscription?.unsubscribe();
  }

  ngOnInit() {
    this.listenToCompanyContext();
    this.updateCompany();
  }

  async cloneSimulation(simulationId: string) {
    try{
      const sim = await firstValueFrom(this._simulationService.getSimulation(simulationId));
      const clone = SimulationCommon.cloneSimulation(sim);
      const saved = await firstValueFrom(this._simulationService.saveSimulation(clone));
      const simulationIdToLog = saved.header?.simulationId ?? '(unknown)';
      console.log(`Saved Simulation ${simulationIdToLog}`);
      this.simulationHeaders = await this.getSimulations(this.company);
    }
    catch(error) {
      this.logUnknownError(error);
    }
  }

  async deleteSimulation(id: string) {
    try{
      await firstValueFrom(this._simulationService.deleteSimulation(id));
      this.simulationHeaders = await this.getSimulations(this.company); 
    }
    catch(error) {
      this.logUnknownError(error);
    }
  }

  async getSimulations(company: CompanyNameViewModel | null) : Promise<SimulationHeader[]> {
    if(!company || !company.companyId) {
      return [];
    }
    return firstValueFrom(this._simulationService.getCompanySimulations(company.companyId));
  }

  listenToCompanyContext() {
    this._companyContextSubscription = this._applicationContextService.companyContextObserver.subscribe(() => this.updateCompany());
  }

  async updateCompany()  {
    try{
      const cmpny = this._applicationContextService.getCompanyContext();
      if (cmpny) {
        this.company = cmpny;
        this.simulationHeaders = await this.getSimulations(cmpny);
      }
    }
    catch(error) {
      this.logUnknownError(error);
    }
  }

  private logUnknownError(error: unknown): void {
    const message = error instanceof Error ? error.message : String(error);
    console.error('An error occurred: ', message);
  }
}
